import { useSyncExternalStore } from 'react';

let active = false;
const listeners = new Set<() => void>();
export const maintenanceStore = {
  getSnapshot: () => active,
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
  set(value: boolean) {
    if (active === value) return;
    active = value;
    listeners.forEach((listener) => listener());
  },
};
export const useMaintenance = () => useSyncExternalStore(maintenanceStore.subscribe, maintenanceStore.getSnapshot);
